/* ============================================================
   GW · Reseñas
   Filtrar, ordenar, enseñar unas pocas y dejar cargar más o
   menos. Y abrir las fotos a pantalla completa.
   Las reseñas están todas en el HTML: filtrar es esconder, no
   pedir nada al servidor.
   ============================================================ */

if (!customElements.get('gw-resenas')) {
  class GwResenas extends HTMLElement {
    connectedCallback() {
      this.lista = this.querySelector('[data-gwrs-lista]');
      this.cards = Array.from(this.querySelectorAll('[data-gwrs-card]'));
      if (!this.lista || !this.cards.length) return;

      this.inicio = Number(this.dataset.inicio || 4);
      this.paso = Number(this.dataset.paso || 4);
      this.visibles = this.inicio;
      this.filtro = 'todas';

      this.mas = this.querySelector('[data-gwrs-mas]');
      this.menos = this.querySelector('[data-gwrs-menos]');
      this.cuenta = this.querySelector('[data-gwrs-cuenta]');
      this.vacio = this.querySelector('[data-gwrs-vacio]');

      this.iniciarFiltros();
      this.iniciarBotones();
      this.iniciarVisor();

      this.aplicar();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.alTeclear);
    }

    iniciarFiltros() {
      this.filtros = Array.from(this.querySelectorAll('[data-gwrs-filtro]'));
      this.filtros.forEach((boton) => {
        boton.addEventListener('click', () => {
          this.filtro = boton.dataset.gwrsFiltro;
          this.visibles = this.inicio;
          this.filtros.forEach((b) => b.setAttribute('aria-pressed', String(b === boton)));
          this.aplicar();
        });
      });
    }

    iniciarBotones() {
      this.mas?.addEventListener('click', () => {
        this.visibles += this.paso;
        this.aplicar();
      });

      this.menos?.addEventListener('click', () => {
        this.visibles = this.inicio;
        this.aplicar();
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* Qué reseñas pasan el filtro, ya en el orden que toca */
    seleccion() {
      let lista = this.cards.slice();

      if (this.filtro === 'con_fotos') {
        lista = lista.filter((c) => c.dataset.fotos === 'si');
      } else if (this.filtro === 'sin_fotos') {
        lista = lista.filter((c) => c.dataset.fotos !== 'si');
      } else if (this.filtro === 'mejores') {
        lista.sort((a, b) => Number(b.dataset.estrellas || 0) - Number(a.dataset.estrellas || 0));
      }

      return lista;
    }

    aplicar() {
      const lista = this.seleccion();

      this.cards.forEach((c) => { c.hidden = true; });

      lista.slice(0, this.visibles).forEach((c, i) => {
        c.hidden = false;
        c.style.order = String(i);
      });

      const mostradas = Math.min(this.visibles, lista.length);

      if (this.mas) this.mas.hidden = lista.length <= this.visibles;
      if (this.menos) this.menos.hidden = this.visibles <= this.inicio || lista.length <= this.inicio;
      if (this.vacio) this.vacio.hidden = lista.length > 0;

      if (this.cuenta) {
        this.cuenta.textContent = lista.length
          ? mostradas + ' de ' + lista.length
          : '';
      }
    }

    /* ---------- Visor de fotos ---------- */

    iniciarVisor() {
      this.visor = this.querySelector('[data-gwrs-visor]');
      if (!this.visor) return;

      this.visorImg = this.visor.querySelector('img');
      this.alTeclear = (e) => { if (e.key === 'Escape') this.cerrarVisor(); };

      this.querySelectorAll('[data-gwrs-foto]').forEach((boton) => {
        boton.addEventListener('click', () => {
          const grande = boton.dataset.gwrsFoto;
          if (!grande || !this.visorImg) return;
          this.visorImg.src = grande;
          this.visor.classList.add('visible');
          document.addEventListener('keydown', this.alTeclear);
        });
      });

      this.visor.addEventListener('click', () => this.cerrarVisor());
    }

    cerrarVisor() {
      this.visor?.classList.remove('visible');
      document.removeEventListener('keydown', this.alTeclear);
    }
  }

  customElements.define('gw-resenas', GwResenas);
}